import React from 'react';
import Check from './icons/check';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelClassName?: string;
  labelTextClassName?: string;
  checkboxClassName?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, labelClassName, labelTextClassName, checkboxClassName, ...props }) => {
  
  if (!label) return null;

  return (
    <label className={`inline-flex items-center gap-2 cursor-pointer select-none ${labelClassName && labelClassName}`}>
      <input
        type="checkbox"
        className="peer sr-only"
        {...props}
      />
      <span
        className={`[&>svg]:hidden [&>svg]:peer-checked:block w-5 h-5 rounded-[7px] border border-neutral-300 peer-checked:border-black flex items-center justify-center transition-colors duration-75 ${checkboxClassName && checkboxClassName}`}
      >
        <Check aria-label="" aria-hidden={true} />
      </span>
      <RichText 
        field={{
          value: label
        }}
        className={`text-sm text-[#333333] font-medium ${labelTextClassName && labelTextClassName}`}
      />
    </label>
  );
};
